// @flow

const resellerTypes = {
    /* eslint-disable sort-keys */
    NOT_A_RESELLER: 0,
    RESELLER: 1,
    /* eslint-enable sort-keys */
};

export default resellerTypes;
